(() => {
  const SPEED = 55;
  const MAX_COPIES = 16;
  const OBSERVE_LIMIT = 15000;

  const hoistEmbeddedMedals = () => {
    const wrapper = document.querySelector('.jdgm-rev-widg .jdgm-medals-wrapper');
    if (!wrapper) return false;
    const reviewWidget = wrapper.closest('.jdgm-rev-widg, .jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
    if (!reviewWidget || !reviewWidget.parentElement) return false;
    wrapper.classList.add('jdgm-medals-wrapper--hoisted');
    reviewWidget.parentElement.insertBefore(wrapper, reviewWidget);
    return true;
  };

  const medalsSettled = (container, originals) => {
    for (let i = 0; i < originals.length; i += 1) {
      if (!originals[i].offsetWidth) return false;
    }
    const images = container.querySelectorAll('img');
    for (let i = 0; i < images.length; i += 1) {
      if (!images[i].complete || !images[i].naturalWidth) return false;
    }
    return true;
  };

  const setupOne = (medals) => {
    const container = medals && medals.querySelector('.jdgm-medals__container');
    if (!container || medals.dataset.ibscentMarquee) return false;
    const originals = Array.prototype.slice.call(container.children);
    if (!originals.length) return false;
    if (!medalsSettled(container, originals)) return false;

    const baseWidth = container.scrollWidth;
    if (baseWidth < 1) return false;
    const viewport = medals.clientWidth || baseWidth;

    let copies = Math.ceil((viewport * 2 + 20) / baseWidth);
    if (copies < 2) copies = 2;
    if (copies > MAX_COPIES) copies = MAX_COPIES;

    const fragment = document.createDocumentFragment();
    for (let pass = 1; pass < copies; pass += 1) {
      originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        fragment.appendChild(clone);
      });
    }
    container.appendChild(fragment);

    const setWidth = container.scrollWidth / copies;
    container.style.setProperty('--ibscent-marquee-shift', (100 / copies) + '%');
    container.style.setProperty('--ibscent-marquee-duration', (setWidth / SPEED) + 's');
    medals.dataset.ibscentMarquee = 'true';
    medals.classList.add('jdgm-medals--marquee');
    return true;
  };

  const retryLater = (medals, attempts) => {
    if (attempts <= 0 || medals.dataset.ibscentMarquee) return;
    setTimeout(() => {
      if (!setupOne(medals)) retryLater(medals, attempts - 1);
    }, 250);
  };

  const watchUntilMeasurable = (medals) => {
    if (medals.dataset.ibscentMarqueeWatch) return;
    const container = medals.querySelector('.jdgm-medals__container');
    if (!container) return;
    medals.dataset.ibscentMarqueeWatch = 'true';
    retryLater(medals, 24);
    if (typeof ResizeObserver !== 'function') return;
    const sizeWatch = new ResizeObserver(() => {
      if (!setupOne(medals)) return;
      sizeWatch.disconnect();
    });
    sizeWatch.observe(container);
    setTimeout(() => {
      sizeWatch.disconnect();
    }, OBSERVE_LIMIT);
  };

  const setup = () => {
    hoistEmbeddedMedals();
    const allMedals = document.querySelectorAll('.jdgm-medals');
    if (!allMedals.length) return false;
    let anyReady = false;
    allMedals.forEach((medals) => {
      if (setupOne(medals)) anyReady = true;
      else if (!medals.dataset.ibscentMarquee) watchUntilMeasurable(medals);
    });
    return anyReady;
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      setup();
    });
  };

  const boot = () => {
    setup();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
    }, OBSERVE_LIMIT);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
